/** Monthly support fee for smaller property-management companies. */
export const SUPPORT_FEE_UNDER_300 = 199;
export const SUPPORT_FEE_300_TO_599 = 124;
export const SUPPORT_FEE_600_TO_899 = 74;
export const SUPPORT_FEE_WAIVED_FROM_UNITS = 900;

export function calculateSupportFee(units: number): number {
  if (units < 300) return SUPPORT_FEE_UNDER_300;
  if (units < 600) return SUPPORT_FEE_300_TO_599;
  if (units < SUPPORT_FEE_WAIVED_FROM_UNITS) return SUPPORT_FEE_600_TO_899;
  return 0;
}

export type SupportFeeTierKey =
  | "unter300Einheiten"
  | "k300599Einheiten"
  | "k600899Einheiten"
  | "ab900Einheiten";

export type SupportFeeDisplayTier = {
  readonly labelKey: SupportFeeTierKey;
  readonly amount: number;
  readonly waived: boolean;
};

/** Ascending by units; the 2×2 table fills column by column. */
export const SUPPORT_FEE_DISPLAY_TIERS: readonly SupportFeeDisplayTier[] = [
  {
    labelKey: "unter300Einheiten",
    amount: SUPPORT_FEE_UNDER_300,
    waived: false,
  },
  {
    labelKey: "k300599Einheiten",
    amount: SUPPORT_FEE_300_TO_599,
    waived: false,
  },
  {
    labelKey: "k600899Einheiten",
    amount: SUPPORT_FEE_600_TO_899,
    waived: false,
  },
  { labelKey: "ab900Einheiten", amount: 0, waived: true },
];
